import React from 'react';
import Language from "@Components/Language";
import footerLogo from "@Assets/images/footer-logo.svg";

type FooterProps = { branding: string; whiteLinks?: boolean };

export default function Footer(props: FooterProps) {
  const {branding, whiteLinks} = props;
  const isAlinta = branding === "ALINTA";
  const linkClass = whiteLinks ? 'text-white' : undefined;

  return (
    <>
    {!isAlinta ? (
      <>
        <div>
          {Language.get('The JMS platform is brought to you by')} <img src={footerLogo} alt="footer-logo"/>
        </div>
        <span>
          &copy;{new Date().getFullYear()}. {Language.get('All rights reserved')}  |
          {' '}
          <a href="/privacy-policy" className={linkClass} target="_blank" rel="noopener noreferrer">{Language.get('Privacy Policy')}</a>
          {'  |  '}
          <a href="/eula" className={linkClass} target="_blank" rel="noopener noreferrer">{Language.get('EULA')}</a>
        </span>
      </>
    ) : (
      <div className="flex relative text-center w-full align-items-center justify-content-center flex-column md:flex-row">
        {import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO && (
          <img src={import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO
            &&  new URL(import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO, import.meta.url).href} alt="No Results" className="max-w-15rem mr-4 mobile-invert" />
        )}
        <>
          <span>&copy;{new Date().getFullYear()}. {Language.get('Journey Management System. All rights reserved.')}</span>
          <span>
            &nbsp;{Language.get('An')}&nbsp;<img src={footerLogo} alt="footer-logo"/>&nbsp;{Language.get('Product.')}
            {' '}
            <a href="/eula" className={linkClass} target="_blank" rel="noopener noreferrer">{Language.get('EULA')}</a>
          </span>
        </>
      </div>
    )}
    </>
  )
};
